package com.eladfinish.bible.contest.screens.browse.tableOfContents

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.Stable
import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.BookmarkData
import com.eladfinish.bible.contest.screens.chapterComplete.model.BlanksRecord
import com.eladfinish.bible.contest.ui.menus.actions.BrowseToolbarAction
import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.collections.immutable.ImmutableList

@Immutable
data class BrowseTabsState(
    val tabs: ImmutableList<StringDesc>,
    val isSkipReadMeChecked: Boolean,
    val isLoading: Boolean,
    val dialogState: DialogState,
) : StateKt {
    @Stable
    sealed class DialogState {
        data class Help(
            val isDontShowAgainChecked: Boolean,
        ) : DialogState()

        data class FontSize(
            val currentFontSize: Float,
        ) : DialogState()

        data class SavedCompletions(
            val title: StringDesc,
            val presets: ImmutableList<StringDesc>,
            val savedItems: ImmutableList<String>,
        ) : DialogState()

        data class RemoteSavedCompletions(
            val title: StringDesc,
            val items: ImmutableList<String>,
            val blanksRecords: ImmutableList<BlanksRecord>,
        ) : DialogState()

        data object None : DialogState()
    }
}

sealed class BrowseTabsAction : ActionKt {
    data class ToolbarClicked(val toolbarAction: BrowseToolbarAction) : BrowseTabsAction()
    data class ToggleHelp(val shouldShowNextTime: Boolean) : BrowseTabsAction()
    data class UpdateFontSize(val value: Float) : BrowseTabsAction()
    data class LoadChapterCompletionByIndex(val index: Int) : BrowseTabsAction()
    data class LoadRemoteChapterCompletion(val blanksRecord: BlanksRecord) : BrowseTabsAction()
    data object HideDialog : BrowseTabsAction()
    data object BackClicked : BrowseTabsAction()
}

sealed class BrowseTabsEffect : EffectKt {
    data object NavigateBack : BrowseTabsEffect()
    data object NavigateToBibleTab : BrowseTabsEffect()
    data object NotifyNoBookmark : BrowseTabsEffect()
    data class HandleBookmark(val bookmarkData: BookmarkData) : BrowseTabsEffect()
    data class HandleRemoteChapterCompletionSelected(
        val bookIndex: Int,
        val chapterIndex: Int,
        val completionDetails: String,
    ) : BrowseTabsEffect()
}
